import { api } from "@/api";

const taxesStore = {
  state: {
    mevReports: [],
    taxePayments: []
  },
  getters: {
    getMevReports(state) {
      return state.mevReports;
    },
    getTaxePayments(state) {
      return state.taxePayments;
    }
  },
  mutations: {
    setMevReports(state, value) {
      state.mevReports = value;
    },
    addMevReport(state, value) {
      state.mevReports.push(value);
    },
    setTaxePayments(state, value) {
      state.taxePayments = value;
    },
    addTaxePayment(state, value) {
      state.taxePayments.push(value);
    }
  },
  actions: {
    async loadMevReports(context) {
      const res = await api.getMevReports();
      context.commit("setMevReports", res);
    },
    async addMevReport(context, payload) {
      const res = await api.postMevReport(payload);
      context.commit("addMevReport", res);
    },
    async loadTaxePayments(context) {
      const res = await api.getTaxePayments();
      context.commit("setTaxePayments", res);
    },
    async addTaxePayment(context, payload) {
      const res = await api.postTaxePayment(payload);
      context.commit("addTaxePayment", res);
      return res;
    }
  }
};

export default taxesStore;
